import React from 'react'
import Layout from '../../../components/layout/Layout'
import { UseCasesView } from '../../../components/pages/usecases'

const siteMetadata = {
  description: "Multi-Agent Use Cases - Code implementations across various frameworks",
  title: "Multi-Agent Use Cases",
  author: "Victor Dibia",
  image: "/images/og-card-usecases.png",
  keywords: "multi-agent systems, use cases, code, implementations, frameworks",
  twitterUsername: "@designingwithml",
};

const UseCasesPage: React.FC = () => {
  return (
    <Layout meta={siteMetadata} title="Use Cases" link={"/labs/usecases"}>
      <main className="">
        <div className="mb-6"></div>
        <UseCasesView isComponent={false} />
      </main>
    </Layout>
  )
}

export default UseCasesPage